import { Link } from 'react-router-dom';
import {
  IconNeedle,
  IconLeaf,
  IconHeart,
} from '@tabler/icons-react';
import { useSiteContent } from '../context/SiteContentContext';
import { getPageImage } from '../lib/imageStore';
import GuyanaStripe from '../components/layout/GuyanaStripe';
import PageTitle from '../components/ui/PageTitle';
import './AboutPage.css';

export default function AboutPage() {
  var content = useSiteContent();
  var c = content.c;

  var workshopImg = getPageImage('about_workshop');
  var leatherImg = getPageImage('about_leather');

  var values = [
    { icon: IconNeedle, title: c('about_value_1_title', 'Made by hand'), body: c('about_value_1_body') },
    { icon: IconLeaf, title: c('about_value_2_title', 'Built to last'), body: c('about_value_2_body') },
    { icon: IconHeart, title: c('about_value_3_title', 'Honest pricing'), body: c('about_value_3_body') },
  ];

  var steps = [
    { num: '01', title: 'Select', desc: 'Hand-picking the finest hides from trusted tanners.' },
    { num: '02', title: 'Cut & shape', desc: 'Each piece is measured, marked, and cut by hand.' },
    { num: '03', title: 'Stitch', desc: 'Saddle-stitched with waxed linen thread for strength.' },
    { num: '04', title: 'Finish', desc: 'Edges burnished, hardware fitted, final inspection.' },
  ];

  return (
    <>
      <PageTitle title="About" />
      <section className="about-hero page-band">
        <span className="about-hero__eyebrow page-band__eyebrow">{c('about_hero_eyebrow')}</span>
        <h1 className="about-hero__headline page-band__title">
          {c('about_hero_headline', 'Every bag tells a story.').split('This is mine').map(function(part, i, arr) {
            return i < arr.length - 1 ? <span key={i}>{part}<em>This is mine.</em></span> : part.replace('.', '');
          })}
        </h1>
      </section>

      <GuyanaStripe />

      <section className="container about-story">
        {workshopImg ? <div className="about-story__img" style={{ background: 'none' }}><img src={workshopImg} alt="Workshop" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /></div> : <div className="about-story__img">Workshop photo</div>}
        <div className="about-story__text">
          <h2 className="about-story__heading">{c('about_story_1_heading')}</h2>
          <p className="about-story__body">{c('about_story_1_body')}</p>
        </div>
      </section>

      <section className="container about-story about-story--reverse">
        <div className="about-story__text">
          <h2 className="about-story__heading">{c('about_story_2_heading')}</h2>
          <p className="about-story__body">{c('about_story_2_body')}</p>
        </div>
        {leatherImg ? <div className="about-story__img" style={{ background: 'none' }}><img src={leatherImg} alt="Leather" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /></div> : <div className="about-story__img">Leather detail photo</div>}
      </section>

      <section className="container about-values">
        {values.map(function(v, i) {
          return (
            <div className="about-value-card" key={i}>
              <div className="about-value-card__icon"><v.icon size={22} /></div>
              <h3 className="about-value-card__title">{v.title}</h3>
              <p className="about-value-card__body">{v.body}</p>
            </div>
          );
        })}
      </section>

      <section className="about-process">
        <h2 className="about-process__heading">From hide to hand</h2>
        <div className="about-process__grid">
          {steps.map(function(step) {
            return (
              <div className="about-process__step" key={step.num}>
                <span className="about-process__num">{step.num}</span>
                <h3 className="about-process__title">{step.title}</h3>
                <p className="about-process__desc">{step.desc}</p>
              </div>
            );
          })}
        </div>
      </section>

      <section className="about-cta">
        <h2 className="about-cta__heading">Ready to see the collection?</h2>
        <Link to="/shop" className="about-cta__btn">Shop the collection</Link>
      </section>
    </>
  );
}